/* eslint-disable @typescript-eslint/no-explicit-any */
import { Grid, OutlinedAdornment, TextField, OutlinedAddon } from '@maas-components/core'
import { useFormikContext } from 'formik'
import i18n from 'core/common/i18n'
import convertDecimalPlaces from 'core/common/utils/convertDecimalPlaces'
import { isNumber } from 'core/common/utils/is'
import { validateField, getErrorMessage } from 'core/common/utils/validation'
import { TFreights } from 'core/services/models/freight'
import { ProductFreightV2Values } from '../constants'
import FreightSelect from './FreightSelect'

interface DimensionFormProps {
  freights: TFreights[]
  handleChangleFreight: (value: string, index: number) => void
  selectedDimension: string
  selectedPackage: string
  selectedFreights: string | undefined
  variationIndex?: number
  formikValidations?: any
  index: number
}

const DimensionForm: React.FC<DimensionFormProps> = ({
  freights,
  handleChangleFreight,
  selectedDimension,
  selectedPackage,
  selectedFreights,
  variationIndex,
  formikValidations,
  index,
}) => {
  const { handleBlur, setFieldValue, errors, submitCount, touched, values } =
    useFormikContext<ProductFreightV2Values>()
  const variationPrefix = isNumber(variationIndex) ? `variations.${variationIndex}.` : ''

  const isVariation = Boolean(variationPrefix)
  const variationDimensions = {
    depth: values.variations?.[variationIndex as number]?.package?.depth?.toString(),
    width: values.variations?.[variationIndex as number]?.package?.width?.toString(),
    height: values.variations?.[variationIndex as number]?.package?.height?.toString(),
  }

  if (selectedPackage === 'standard') {
    return (
      <Grid item xs={9}>
        <FreightSelect
          index={index}
          freights={freights}
          value={selectedFreights}
          onSelect={handleChangleFreight}
          formikValidations={formikValidations}
        />
      </Grid>
    )
  }

  return (
    <>
      <Grid item xs={3}>
        <OutlinedAdornment
          position="end"
          error={validateField('package.depth', errors, touched, submitCount > 0)}
        >
          <TextField
            error={validateField(
              `${variationPrefix}package.depth`,
              errors,
              touched,
              submitCount > 0
            )}
            helperText={getErrorMessage(`${variationPrefix}package.depth`, errors, touched)}
            onBlur={handleBlur}
            variant="outlined"
            label={i18n.t('productNew.logistic.depthLabelForm')}
            name={`${variationPrefix}package.depth`}
            value={isVariation ? variationDimensions.depth : values.package?.depth?.toString()}
            onChange={e => {
              const newValue = e.target.value.slice(0, 7)
              setFieldValue(`${variationPrefix}package.depth`, convertDecimalPlaces(newValue))
            }}
            style={{ backgroundColor: '#fff' }}
            type="number"
          />
          <OutlinedAddon position="end">{selectedDimension}</OutlinedAddon>
        </OutlinedAdornment>
      </Grid>
      <Grid item xs={3}>
        <OutlinedAdornment
          position="end"
          error={validateField(`${variationPrefix}package.width`, errors, touched, submitCount > 0)}
        >
          <TextField
            error={validateField(
              `${variationPrefix}package.width`,
              errors,
              touched,
              submitCount > 0
            )}
            helperText={getErrorMessage(`${variationPrefix}package.width`, errors, touched)}
            onBlur={handleBlur}
            variant="outlined"
            label={i18n.t('productNew.logistic.widthLabelForm')}
            name={`${variationPrefix}package.width`}
            value={isVariation ? variationDimensions.width : values.package?.width?.toString()}
            onChange={e => {
              const newValue = e.target.value.slice(0, 7)
              setFieldValue(`${variationPrefix}package.width`, convertDecimalPlaces(newValue))
            }}
            style={{ backgroundColor: '#fff' }}
            type="number"
          />
          <OutlinedAddon position="end">{selectedDimension}</OutlinedAddon>
        </OutlinedAdornment>
      </Grid>
      <Grid item xs={3}>
        <OutlinedAdornment
          position="end"
          error={validateField(
            `${variationPrefix}package.height`,
            errors,
            touched,
            submitCount > 0
          )}
        >
          <TextField
            error={validateField(
              `${variationPrefix}package.height`,
              errors,
              touched,
              submitCount > 0
            )}
            helperText={getErrorMessage(`${variationPrefix}package.height`, errors, touched)}
            onBlur={handleBlur}
            variant="outlined"
            label={i18n.t('productNew.logistic.heightLabelForm')}
            name={`${variationPrefix}package.height`}
            value={isVariation ? variationDimensions.height : values.package?.height?.toString()}
            onChange={e => {
              const newValue = e.target.value.slice(0, 7)
              setFieldValue(`${variationPrefix}package.height`, convertDecimalPlaces(newValue))
            }}
            style={{ backgroundColor: '#fff' }}
            type="number"
          />
          <OutlinedAddon position="end">{selectedDimension}</OutlinedAddon>
        </OutlinedAdornment>
      </Grid>
    </>
  )
}

export default DimensionForm
